import clsx from "clsx";
import React, { useMemo, useState } from "react";

import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownItems,
} from "@transfr-inc/dashboard-components/forms";

import { ProgramDropdownOption } from "./program-dropdown-option";

import "./program-dropdown-list.scss";

export function ProgramDropDownList({
  placeholder = "Select a Program",
  programs,
  className,
  onProgramSelected,
  clearEnabled,
  defaultProgram,
}) {
  const [selectedProgram, setSelectedProgram] = useState(defaultProgram);

  const onOptionSelected = (option) => {
    setSelectedProgram(option);
    onProgramSelected(option);
  };

  const programOptions = useMemo(() => {
    return programs?.map((p) => {
      return (
        <DropdownItem
          className="program-dropdown-option"
          key={`program-${p.id}`}
          value={p}
        >
          <ProgramDropdownOption program={p} />
        </DropdownItem>
      );
    });
  }, [programs]);

  return (
    <div className={clsx("program-drop-down-list", className)}>
      <Dropdown
        selected={selectedProgram}
        onOptionSelected={onOptionSelected}
        className="program-dropdown"
      >
        <DropdownButton
          placeholder={placeholder}
          required
          clearEnabled={clearEnabled}
        >
          {selectedProgram && (
            <ProgramDropdownOption program={selectedProgram} />
          )}
        </DropdownButton>
        <DropdownItems minHeight={150}>{programOptions}</DropdownItems>
      </Dropdown>
    </div>
  );
}
